$(document).ready(function () {

    if (formErrors) {
        $.each(formErrorMessages, function (inputID, errorMessage) {
            var message = translate[errorMessage['message']] != undefined ? translate[errorMessage['message']] : errorMessage['message'];
            var replacement = errorMessage['replacement'];
            if (replacement) {
                message = $.validator.format(message, replacement);
            }

            var inputNode = $("[id^='"+ inputID+"']");

            if (inputNode) {
                var em = '<em class="error help-block">' + message + '</em>';
                inputNode.after(em);
            }
        });
    }

    $('.important').keyup( function () {
        $(this).removeClass('border-bottom-error');
        var val = $(this).val();
        val = val.replace(/ /g, '')
        val = $.trim(val);
        $(this).val(val);
    });

    if($("#retrieve_password_form_email").length > 0){
        $("#retrieve_password_form_email").val('');
        $("#retrieve_password_form_email").focus();
    }
    $('#forgot-password').on('submit', function (e) {
        var email = $.trim($('#retrieve_password_form_email').val());
        var elem = $("#retrieve_password_form_email");
        $('#retrieve_password_form_email').val(email);
        if (!validateEmail(email)) {
            if($(".help-block").length === 0){
                $('<em class="error help-block">'+ translate['Email field must be filled properly.'] +'</em>').insertBefore(elem);
            } else {
                $(".help-block").first().text(translate['Email field must be filled properly.']);
            }
            $(elem).addClass('border-bottom-error');
            e.preventDefault();
        } else {
            $(".help-block").remove();
            $("#retrieve-password-form-submit").attr('disabled', true);
        }
    });

    $(".form-group input").removeAttr('required');

    $(document).on('input change', '.important', function () {
        if ($.trim($(this).val()) != '') {
            $(this).removeClass('border-bottom-error');
        }
    });

    function checkPassword(str)
    {
        // at least one number, one lowercase and one uppercase letter
        // at least six characters
        return /^(?=.*\d)(?=.*[a-zA-Z])\w{5,}$/.test(str);
    }
    if(jQuery.validator){
        jQuery.validator.addMethod("password", function(value, element) {
            return checkPassword(value);
        }, translate['Please enter at least one number, at least 5 characters']);

    }

    if($("#plainPassword_first").length > 0){
        $("#plainPassword_first").focus();
    }

    if(jQuery.validator){
        $('#reset_password').validate({
            onkeyup: false,
            rules: {
                "plainPassword[first]" : {
                    required: true,
                    minlength: 5,

                },
                "plainPassword[second]" : {
                    equalTo: "#plainPassword_first",
                    required: true,
                }
            },
            errorElement: "em",
            errorPlacement: function ( error, element ) {
                // Add the `help-block` class to the error element

                error.addClass( "help-block" );
                error.insertBefore( element );

            },
            highlight: function ( element, errorClass, validClass ) {
                $( element ).parents( ".col-sm-5" ).addClass( "has-error" ).removeClass( "has-success" );
                $(element).addClass('border-bottom-error');
            },
            unhighlight: function (element, errorClass, validClass) {
                $( element ).parents( ".col-sm-5" ).addClass( "has-success" ).removeClass( "has-error" );
                $(element).removeClass('border-bottom-error');
            }
        });
    }

    if (typeof jQuery.validator !== 'undefined') {
        jQuery.extend(jQuery.validator.messages, {
            required: translate['This field is required.'],
            email: translate['Please enter a valid email address.'],
            maxlength: $.validator.format( translate['Please enter no more than {0} characters.']),
            equalTo: translate['Please enter the same value again.']
        });
    }
});